<template>
  <div class="event-progress-wrapper" v-if="activityDetail">
    <div class="max-w event-progress-inner">
      <div class="event-left">
        <div class="back-btn" @click="backPage">返 回</div>
        <div class="event-name">{{ activityDetail.name }}</div>
      </div>
      <div class="event-right">
        <div class="event-score">
          <img src="../../assets/image/student/common/progress-fullscore.png">
          <span>满分 · {{activityDetail.total_score}}分</span>
        </div>
        <div class="event-score ml-72">
          <img src="../../assets/image/student/common/progress-userscore.png">
          <span>得分 · {{ activityDetail.score }}</span>
        </div>
        <div class="progress-info">
          <div class="label">整体进度</div>
          <div class="progress-wrapper">
            <div class="progress-inner" :style="{width:`${(activityDetail.task/activityDetail.total_task) * 100}%`}"></div>
          </div>
          <div class="progress-num">
            {{ activityDetail.task }} / {{ activityDetail.total_task }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
      school_code: localStorage.getItem("schoolCode")
    }
  },
  computed: {
    ...mapState({
      activityDetail: (state) => state.train.activityDetail,
    }),
  },
  mounted () {
    this.getActivityDetail()
  },
  methods: {
    ...mapActions(['methodActivityDetail']),
    async getActivityDetail () {
      await this.methodActivityDetail({ id: this.$route.query.activity_id });
    },
    backPage () {
      this.$router.push(`/${this.school_code}/student`)
    }
  },
}
</script>

<style lang="less" scoped>
.event-progress-wrapper {
    width: 100%;
    position: fixed;
    top: 54px;
    left: 0;
    width: 100%;
    height: 55px;
    background: #ffffff;
    border-bottom: 1px solid #dddada;
    z-index: 100;
    .event-progress-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        .event-left {
            display: flex;
            align-items: center;
            .back-btn {
                width: 74px;
                height: 28px;
                border-radius: 10px;
                background: #b84b3c;
                text-align: center;
                line-height: 28px;
                font-size: 14px;
                color: #fff;
                border-radius: 14px;
                cursor: pointer;
                margin-right: 25px;
                flex-shrink: 0;
                &:hover {
                    background: #a82822;
                }
            }
            .event-name {
                font-weight: bold;
                font-size: 17px;
                color: #302e2f;
            }
        }
        .event-right {
            display: flex;
            align-items: center;
            .event-score {
                img {
                    height: 12px;
                    width: auto;
                    vertical-align: -1px;
                }
                span {
                    margin-left: 10px;
                    font-size: 16px;
                    color: #302e2f;
                }
                &.ml-72 {
                    margin: 0 120px 0 72px;
                }
            }
            .progress-info {
                font-size: 16px;
                color: #302e2f;
                display: flex;
                align-items: center;
                .progress-wrapper {
                    width: 96px;
                    height: 5px;
                    background: #e8ebed;
                    border-radius: 3px;
                    overflow: hidden;
                    margin: 0 12px 0 10px;
                    position: relative;
                    .progress-inner {
                        background: linear-gradient(
                            90deg,
                            #e15c56 0%,
                            #a82822 100%
                        );
                        height: 100%;
                        border-radius: 3px;
                    }
                }
                .progress-num {
                    font-size: 14px;
                    color: #888a8c;
                }
            }
        }
    }
}
</style>